
import { getAdminLocations, getAdminLocation } from '../api'

export const getAdminPlaces = async (paginate) => {
  const req = await getAdminLocations(paginate)
  return { type: 'GET_ADMIN_PLACES_SUCCESS', data: req.locations }
}

export const getAdminPlace = async (slug) => {
  const req = await getAdminLocation(slug)
  return { type: 'GET_ADMIN_PLACE_SUCCESS', data: req.location }
}
